// 融媒管家
export default {
  path: '/rmplus',
  title: ' 融媒管家',
  icon: 'wechat',
  hideSub: true,
  children: (pre => [
    {
      title: '概览',
      icon: 'wrench',
      path: `${pre}index`
    },
    {
      title: '矩阵管理',
      icon: 'cubes',
            path: `${pre}account`
     // path: `${pre}index`
    },
    {
      title: '素材中心',
      icon: 'database',
      path: `${pre}material`
    },
    {
      title: '发文管理',
      icon: 'newspaper-o',
      path: `${pre}news`
    },
    // {
    //   title: '数据分析',
    //   icon: 'pie-chart',
    //   path: `${pre}analysis`
    // },
    {
      title: '榜单',
      icon: 'random',
      path: `${pre}rank`,
      children: [
        {
          title: '公众号榜单',
          icon: 'wechat',
          path: `${pre}rank/wechat`
        },
        {
          title: '头条榜单',
          icon: 'list',
          path: `${pre}chart/toutiao`
        },
        {
          title: '微博榜单',
          icon: 'weibo',
          path: `${pre}chart/weibo`
        }
      ]
    },
    {
      title: '融媒大屏',
      icon: 'globe',
      path: `${pre}bigScreen`,
      children: [
        {
          title: '大屏',
          icon: 'globe',
          path: `${pre}bigScreen/bigScreen`
        },
        {
          title: '大屏（竖版）',
          icon: 'globe',
          path: `${pre}bigScreen/vertical`
        },
        {
          title: '大屏管理后台',
          icon: 'home',
          path: `${pre}bigScreen/admin`
        }
      ]
    },
    // {
      
    //   title: '粉丝管理',
    //   icon: 'user',
    //   path: `${pre}user`,
    //   children: [
    //     {
    //       title: '公众号粉丝',
    //       icon: 'wechat',
    //       path: `${pre}user`
    //     },
    //     {
    //       title: '微博粉丝',
    //       icon: 'wechat',
    //       path: `${pre}user1`
    //     }
    //   ]
    // }
  ])('/rmplus/')
}
